import React from "react";
import PropTypes from "prop-types";
import {
	Container,
	Header,
	Description,
	SubHeader,
	BulletPoints,
	DetailsWrapper,
	ImageWrapper,
	PointsWrapper,
	TextPoint,
	CtaContainer,
} from "./styles";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { CtaButton } from "../../Elements";

const GeneralText = ({
	cta,
	header,
	description,
	subHeader,
	bulletPoints,
	image,
	showInTabletAndMobile,
}) => {
	return (
		<Container
			showInTabletAndMobile={showInTabletAndMobile}
			imagePosition={image?.position}
		>
			<Header>{header}</Header>
			<Description
				dangerouslySetInnerHTML={{
					__html: description,
				}}
			/>
			<DetailsWrapper imagePosition={image?.position}>
				<BulletPoints imagePosition={image?.position}>
					<SubHeader>{subHeader}</SubHeader>
					<PointsWrapper>
						{(bulletPoints || []).map((point) => (
							<TextPoint key={point}>{point}</TextPoint>
						))}
					</PointsWrapper>
				</BulletPoints>
				<ImageWrapper>
					<CloudinaryImage
						url={image?.url?.image || ""}
						quality="auto"
						lazyload
						fetchFormat="auto"
						sizes={{
							default: {
								width: 515,
							},
							"322px": {
								width: 515,
							},
						}}
						alt={image?.url?.altTag}
					/>
				</ImageWrapper>
			</DetailsWrapper>
			{cta && (
				<CtaContainer>
					<CtaButton cta={cta} />
				</CtaContainer>
			)}
		</Container>
	);
};

GeneralText.defaultProps = {
	description: "",
	subHeader: "",
	bulletPoints: [],
	image: {},
	showInTabletAndMobile: true,
};

GeneralText.propTypes = {
	header: PropTypes.string.isRequired,
	description: PropTypes.string,
	subHeader: PropTypes.string,
	bulletPoints: PropTypes.array,
	image: PropTypes.object,
	showInTabletAndMobile: PropTypes.bool,
};
export default GeneralText;
